'use strict';

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./util'),
    encodeText = _require.encodeText;
/** @typedef {import('./types').CodecFactory} CodecFactory */

/** @typedef {import("./types").BaseName} BaseName */

/** @typedef {import("./types").BaseCode} BaseCode */

/**
 * Class to encode/decode in the supported Bases
 *
 */


var Base = /*#__PURE__*/function () {
  /**
   * @param {BaseName} name
   * @param {BaseCode} code
   * @param {CodecFactory} factory
   * @param {string} alphabet
   */
  function Base(name, code, factory, alphabet) {
    _classCallCheck(this, Base);

    this.name = name;
    this.code = code;
    this.codeBuf = encodeText(this.code);
    this.alphabet = alphabet;
    this.codec = factory(alphabet);
  }
  /**
   * @param {Uint8Array} buf
   * @returns {string}
   */


  _createClass(Base, [{
    key: "encode",
    value: function encode(buf) {
      return this.codec.encode(buf);
    }
    /**
     * @param {string} string
     * @returns {Uint8Array}
     */

  }, {
    key: "decode",
    value: function decode(string) {
      var _iterator = _createForOfIteratorHelper(string),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;

          if (this.alphabet && this.alphabet.indexOf(char) < 0) {
            throw new Error("invalid character '".concat(char, "' in '").concat(string, "'"));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.codec.decode(string);
    }
  }]);

  return Base;
}();

module.exports = Base;